// Bridge module to access the global joeyConfig variable
declare global {
  interface Window {
    joeyConfig: {
      config: {
        AZUREAD_TENANT_ID: string;
        AZUREAD_CLIENT_ID: string;
        AZUREAD_AUDIENCE: string;
        UI_SENTRY_IO_URL: string;
        SENTRY_ENVIRONMENT: string;
        API_BASE_URL: string;
      };
    };
  }
}

// Access the global variable set by the script in public/config.js
const globalConfig = (window as any).joeyConfig || (globalThis as any).joeyConfig;

if (!globalConfig) {
  throw new Error('joeyConfig global variable not found. Make sure config.js is loaded.');
}

export const config = globalConfig.config;
